<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>Date</th>
          <th>Time</th>
          <th>Name</th>
          <th>Treatment</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(treatment, index) in treatments"
          :key="index"
        >
          <td
            :class="['zero-padding', { tbc: dateIsTbc(treatment.date), invalid: treatment.invalid }]"
            @click.stop="focusInput"
          >
            <input
              type="date"
              :name="index"
              :value="treatment.date"
              :min="minDate"
              :max="maxDate"
              @input="updateDate"
              @change="checkFormValidity"
              @keyup="checkFormValidity"
            >
          </td>
          <td
            :class="['zero-padding', { tbc: timeIsTbc(treatment.time), invalid: treatment.invalid }]"
            @click.stop="focusInput"
          >
            <input
              type="time"
              step="300"
              :name="index"
              :value="treatment.time"
              @input="updateTime"
              @change="checkFormValidity"
              @keyup="checkFormValidity"
            >
          </td>
          <td>{{ treatment.guest_names }}</td>
          <td>{{ treatment.description }}</td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="hasError"
      class="input-error"
    >
      <p>The following treatments have errors:</p>
      <ul>
        <li
          v-for="(errorText, index) in errorTexts()"
          :key="index"
        >
          {{ errorText }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { ukShortDate } from 'lib/date-and-time-formats'
import Treatment from '../../models/Treatment'

export default {
  name: 'TreatmentsTable',

  props: {
    id: {
      type: String,
      required: true
    },

    minDate: {
      type: String,
      default: null
    },

    maxDate: {
      type: String,
      default: null
    },

    treatments: {
      type: Array,
      default: () => []
    },

    treatmentErrors: {
      type: Object,
      default: () => ({})
    },

    updateNestedAttribute: {
      type: Function,
      required: true
    },

    markFormFieldsAsInvalid: {
      type: Function,
      required: true
    }
  },

  computed: {
    hasError () {
      return Object.keys(this.treatmentErrors).length > 0
    }
  },

  methods: {
    focusInput (event) {
      if (event.target.tagName === 'TD') {
        event.target.querySelector('input').focus()
      }
    },

    timeIsTbc (treatmentTime) {
      return treatmentTime === 'TBC'
    },

    dateIsTbc (treatmentDate) {
      return treatmentDate === null
    },

    errorTexts () {
      return Object.entries(this.treatmentErrors).map((entry) => {
        const errors = entry[1]
        const treatmentNumber = parseInt(entry[0]) + 1

        if (errors.time !== undefined) {
          return `Treatment number ${treatmentNumber} has an invalid time`
        } else if (errors.date.includes('outside_range')) {
          const formattedTravelDate = ukShortDate(this.minDate)
          const formatteReturnDate = ukShortDate(this.maxDate)

          return `Treatment number ${treatmentNumber} is invalid. 
                  Date must be between ${formattedTravelDate} & ${formatteReturnDate}`
        } else if (errors.date.includes('invalid')) {
          return `Treatment number ${treatmentNumber} has an invalid date`
        } else {
          return `Treatment number ${treatmentNumber} is invalid`
        }
      })
    },

    checkFormValidity () {
      // We can't access a partial value in a time input & partial values do not
      // fire input events. So we have to check the DOM validity of the time fields
      const inputs = Array.from(document.querySelectorAll('input[type=time], input[type=date]'))

      const allInputsValid = inputs.every((input) => {
        return input.validity.badInput === false
      })
      this.markFormFieldsAsInvalid(this.id, !allInputsValid)
    },

    updateDate (event) {
      this.updateNestedAttribute(this.id, Treatment, 'date', event.target.name, event.target.value)
      this.checkFormValidity()
    },

    updateTime (event) {
      this.updateNestedAttribute(this.id, Treatment, 'time', event.target.name, event.target.value)
      this.checkFormValidity()
    }
  }
}
</script>
